export const COMMUNITY_RULES_VERSION = "2026-09-27.v1" as const;
export const MESSAGE_RECALL_WINDOW_MS = 60_000;

export const REPORT_CATEGORY_RULES = {
  threat: {
    label: "Threat or immediate danger",
    deskLabel: "Threat report",
    priority: 0,
    autoHoldEligible: true,
    requiresMaoriMessage: false,
  },
  hate: {
    label: "Hate or identity-based abuse",
    deskLabel: "Hate report",
    priority: 1,
    autoHoldEligible: true,
    requiresMaoriMessage: false,
  },
  harassment: {
    label: "Harassment or targeted abuse",
    deskLabel: "Harassment report",
    priority: 2,
    autoHoldEligible: true,
    requiresMaoriMessage: false,
  },
  privacy: {
    label: "Private information or impersonation",
    deskLabel: "Privacy report",
    priority: 3,
    autoHoldEligible: true,
    requiresMaoriMessage: false,
  },
  safety: {
    label: "Other safety or conduct concern",
    deskLabel: "Safety report",
    priority: 4,
    autoHoldEligible: true,
    requiresMaoriMessage: false,
  },
  wrong_language: {
    label: "Not using te reo Māori",
    deskLabel: "Language report",
    priority: 5,
    autoHoldEligible: false,
    requiresMaoriMessage: true,
  },
} as const;

export type ReportCategory = keyof typeof REPORT_CATEGORY_RULES;

export const REPORT_CATEGORIES = Object.keys(REPORT_CATEGORY_RULES) as ReportCategory[];
export const AUTO_HOLD_REPORT_CATEGORIES = REPORT_CATEGORIES
  .filter((category) => REPORT_CATEGORY_RULES[category].autoHoldEligible);

export function isReportCategory(input: unknown): input is ReportCategory {
  return typeof input === "string" && Object.hasOwn(REPORT_CATEGORY_RULES, input);
}

export const SLOW_MODE_INTERVALS = [5, 10, 30] as const;
export type SlowModeIntervalSeconds = (typeof SLOW_MODE_INTERVALS)[number];
export const SLOW_MODE_DEFAULT_DURATION_MINUTES = 15;
export const SLOW_MODE_MAX_DURATION_MINUTES = 120;

export type RoomSlowMode = {
  roomId: string;
  intervalSeconds: SlowModeIntervalSeconds;
  enabledAt: number;
  expiresAt: number;
  reason: string;
};
